/**
 * Number on the header bell.
 *
 * Portal audit 2026-09-24: the bell counted EVERY notification returned by
 * /api/notifications/client (the last 50, read or not) plus active announcements.
 * Reading a notification, or "Mark all as read" on /notifications (which sets
 * status='read'), therefore never lowered the badge. Read notifications are now
 * excluded. Other statuses (unread, sent, pending, ...) still count, exactly as
 * before. Active announcements still count: they have no per-user read state, and
 * /notifications shows them under its Announcements tab with the same number.
 */
export function countBellItems(notifications: unknown, announcements: unknown): number {
  const n = Array.isArray(notifications)
    ? notifications.filter((x: any) => x?.status !== 'read').length
    : 0;
  const a = Array.isArray(announcements) ? announcements.length : 0;
  return n + a;
}
